<p-toast></p-toast>
<p-confirmDialog
  rejectButtonStyleClass="p-button-outlined p-button-secondary"
></p-confirmDialog>
<p-scrollTop></p-scrollTop>

<p-confirmDialog
  [style]="{ width: '500px' }"
  key="installConfirmation"
  position="bottom"
  [baseZIndex]="10000"
></p-confirmDialog>

<router-outlet></router-outlet>
